<template>
    <div class="homepageGraphic__counterElement counterElement">
        <div class="counterElement__inner">
            <button
                v-for="(word, index) in countInWords"
                :key="word"
                class="counterElement__trigger"
                :class="[ `-${word}`, { '-active' : word == currentKey } ]"
                :aria-label="`${getTitle(index)}`"
                tabindex="0"
                @click="updateCurrentKeyManual( index + 1)"
                @keyup.enter="updateCurrentKeyManual( index + 1)"
            >
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    class="counterElement__dot"
                >
                    <circle
                        class="counterElement__dotCenter"
                        cx="10"
                        cy="10"
                        r="5"
                        fill="currentColor"
                        stroke="none"
                    />
                    <circle
                        class="counterElement__dotRing"
                        cx="10"
                        cy="10"
                        r="8"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                    />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import converter from 'number-to-words'

export default {

    computed: {
        ...mapState(['currentKey']),
        ...mapGetters(['keyedData']),
        ...mapGetters(['currentData', 'getTitle']),

        title () {
            return this.currentData.title
        },

        countInWords () {
            return Object.keys(this.keyedData).map(key => key)
        },
    },

    methods: {
        updateCurrentKeyManual (key) {
            const current = converter.toWords(key)
            this.$store.dispatch('setCurrentKey', current)
        },
    },
}
</script>
